import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { ReasonData } from "../Pages/Reason";

interface ReasonsViewProps {
  viewData: ReasonData[];
  onEdit: (data: ReasonData) => void;
  onAddClick: () => void;
  showAddButton: boolean;
}

const getReasonType = (typeId: number): string => {
  const types: Record<number, string> = {
    1: "Lead Lost Reason",
    2: "Booking Cancel Reason",
    3: "Type C",
    // 👈 update with your actual reason types
  };
  return types[typeId] ?? `Type ${typeId}`;
};

const ReasonsView: React.FC<ReasonsViewProps> = ({
  viewData,
  onEdit,
  onAddClick,
  showAddButton,
}) => {
  const [toggleCleared, setToggleCleared] = useState(false);

  const handleRowSelected = (state: any) => {
    console.log("Selected rows:", state.selectedRows);
  };

  const columns = [
    {
      name: "Sl No",
      cell: (_row: ReasonData, index: number) => (
        <span style={{ fontWeight: "600", color: "#64748b" }}>{index + 1}</span>
      ),
      width: "80px",
      sortable: false,
    },
    {
      name: "Reason Type",
      selector: (row: ReasonData) => row.typeId,
      sortable: true,
      cell: (row: ReasonData) => {
        const label = getReasonType(row.typeId);
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <div
              style={{
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                backgroundColor: "rgb(167 133 144)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontSize: "10px",
                fontWeight: "bold",
              }}
            >
              {label.charAt(0).toUpperCase()}
            </div>
            <span style={{ fontWeight: "500", color: "#33475b" }}>{label}</span>
          </div>
        );
      },
      width: "200px",
    },
    {
      name: "Reason Name",
      selector: (row: ReasonData) => row.description,
      sortable: true,
      cell: (row: ReasonData) => (
        <span style={{ color: "#33475b" }}>{row.description}</span>
      ),
      width: "300px",
    },
    {
      name: "Status",
      selector: (row: ReasonData) => row.isActive,
      sortable: true,
      cell: (row: ReasonData) => {
        const isActive =
          typeof row.isActive === "boolean"
            ? row.isActive
            : row.isActive === 1;
        return (
          <span className={isActive ? "active-status" : "inactive-status"}>
            {isActive ? "ACTIVE" : "INACTIVE"}
          </span>
        );
      },
      width: "150px",
    },
    {
      name: "",
      cell: (row: ReasonData) => (
        <div className="action-cell">
          <button
            className="action-button edit-button"
            title="Edit Reason"
            onClick={() => onEdit(row)}
          >
            <i className="bi bi-pencil-square"></i>
          </button>
          {/* <button className="action-button more-button" title="More Options">
            <i className="bi bi-three-dots"></i>
          </button> */}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "80px",
      className: "sticky-action-column",
    },
  ];

  return (
    <div className="card">
      <div className="card-header carHeaderWithBtn d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0">Reasons List</h5>
        {showAddButton && (
          <button
            type="button"
            className="demo-btn btn btn-outline-primary btn-sm"
            onClick={onAddClick}
          >
            <i className="fas fa-plus me-1"></i>+ Add Reason
          </button>
        )}
      </div>
      <div className="card-body p-0">
        <DataTable
          columns={columns}
          data={viewData}
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
          highlightOnHover
          striped
          responsive
          noDataComponent={
            <div className="text-center py-4">
              <p className="text-muted mb-0">No reasons found.</p>
            </div>
          }
          selectableRows
          selectableRowsComponentProps={{ className: "custom-checkbox" }}
          onSelectedRowsChange={handleRowSelected}
          clearSelectedRows={toggleCleared}
          fixedHeader
          fixedHeaderScrollHeight="400px"
        />
      </div>
    </div>
  );
};

export default ReasonsView;